import React, { useCallback, useEffect, useState, useMemo } from 'react';
import SignupContentWrapper from '../components/SignupContentWrapper';
import SignupTextField from '../components/SignupTextField';
import { useTranslation } from 'react-i18next';
import { minimumValidation } from '../components/SimpleTextFieldComponent';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { AppState } from '../../../store';
import { OkButton } from '../components/TextFieldWrapper';
import { useNavigate } from 'react-router-dom';
import { signSetAction } from '../../../store/signup/actions';
import Space from '../../../theme/Space';
import { PATH } from '../../../routes';
import { pushEvent } from '../../../utils/clevertapUtils';
import {
    CLICK_USER_NAME_PAGE_OK_BTN,
    VIEW_USER_NAME_PAGE,
} from '../../../utils/clevertapEvents';
import { useRouteConfig } from '../utils/useRouteConfig';

const STEP_INFO = 2;

const UserFirstName: React.FC = () => {
    const { t } = useTranslation();
    const push = useNavigate();
    const dispatch = useAppDispatch();
    const { next, previous } = useRouteConfig(PATH.SIGNUP.STEPS.THREE);
    useEffect(() => {
        pushEvent(VIEW_USER_NAME_PAGE);
    }, []);

    const copy = useMemo(
        () => ({
            errorFirstName: t('signup.userName.errors.firstName'),
            errorLastName: t('signup.userName.errors.lastName'),
            heading: t('signup.userName.heading'),
            placeholderFirstName: t('signup.userName.placeholders.firstName'),
            placeholderLastName: t('signup.userName.placeholders.lastName'),
        }),
        [t],
    );

    const onSubmit = () => {
        pushEvent(CLICK_USER_NAME_PAGE_OK_BTN);
        dispatch(
            signSetAction({
                userFirstName: firstName,
                userLastName: lastName,
            }),
        );
        next && push(next);
    };

    const name = useSelector((state: AppState) => ({
        firstName: state.Signup.userFirstName,
        lastName: state.Signup.userLastName,
    }));

    const [firstName, setFirstName] = useState<string>(name.firstName);
    const [lastName, setLastName] = useState<string>(name.lastName);

    const onChangeFirstName = useCallback((value: string) => {
        setFirstName(value);
    }, []);
    const onChangeLastName = useCallback((value: string) => {
        setLastName(value);
    }, []);

    const isFormValid =
        minimumValidation(firstName) && minimumValidation(lastName);

    return (
        <SignupContentWrapper
            heading={copy.heading}
            stepInfo={STEP_INFO}
            showCloseButton={true}
            backUrl={previous}
        >
            <SignupTextField
                name="firstName"
                value={firstName}
                isFocus={true}
                type="text"
                placeholder={copy.placeholderFirstName}
                onChange={onChangeFirstName}
                validation={minimumValidation}
                maxLength={55}
                errorText={copy.errorFirstName}
            />
            <Space gap={3} />
            <SignupTextField
                name="lastName"
                value={lastName}
                isFocus={undefined}
                type="text"
                errorText={copy.errorLastName}
                placeholder={copy.placeholderLastName}
                onChange={onChangeLastName}
                validation={minimumValidation}
                maxLength={55}
            />
            {isFormValid && <OkButton onSubmit={onSubmit} />}
        </SignupContentWrapper>
    );
};

export default UserFirstName;
